// Uitleg.js: een korte uitleg die verschijnt als de muis op een woord staat.
// Het woord krijgt een klein rondje met een i erachter, zodat te zien is dat
// er uitleg is. Besluit HL 23 oktober 2026 (mockup Laadpleinen V4 tot V7):
// de kleine regels onder de kerncijfers en de toelichting bij de velden staan
// niet meer vast in beeld, maar komen bij aanwijzen.
//
// De uitleg staat los van de pagina (position fixed), zodat hij niet wordt
// afgesneden door een kolom die zelf kan scrollen.

import React, { useRef, useState } from 'react';

const BREED = 330;

export function Ikoon() {
  return (
    <span style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:14, height:14,
                   borderRadius:'50%', border:'1px solid #9AA4B1', color:'#6B7684', fontSize:10, fontWeight:700,
                   fontStyle:'normal', marginLeft:5, verticalAlign:1, textTransform:'none', letterSpacing:0,
                   lineHeight:1, flexShrink:0 }}>i</span>
  );
}

// tekst: de uitleg (tekst of JSX). Zonder tekst geeft dit alleen de inhoud terug.
// ikoon: false laat het rondje weg, bijvoorbeeld bij een knop.
export default function Uitleg({ tekst, children, ikoon = true, style, as = 'span' }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(null);
  if (!tekst) return React.createElement(as, { style }, children);
  const toon = () => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    const x = Math.max(8, Math.min(r.left, window.innerWidth - BREED - 12));
    // Onder het woord, of erboven als er onderaan geen plaats is.
    const onder = r.bottom + 8;
    setPos(onder + 140 > window.innerHeight ? { left: x, bottom: window.innerHeight - r.top + 8 } : { left: x, top: onder });
  };
  return React.createElement(as, {
    ref, style: { cursor:'help', ...style },
    onMouseEnter: toon, onMouseLeave: () => setPos(null),
  }, children, ikoon && <Ikoon />, pos && (
    <span style={{ position:'fixed', zIndex:3000, ...pos, maxWidth:BREED, background:'#12161C', color:'#fff',
                   fontSize:13.5, fontWeight:400, lineHeight:1.45, padding:'9px 12px', borderRadius:7,
                   pointerEvents:'none', boxShadow:'0 4px 14px rgba(0,0,0,.25)', textTransform:'none',
                   letterSpacing:0, whiteSpace:'normal', textAlign:'left', display:'block' }}>{tekst}</span>
  ));
}
